/**
 * TouchAdapter - Handles touch events for the GestureController
 * Normalizes touch input to x/y coordinates
 */
export class TouchAdapter {
  constructor(controller) {
    this.controller = controller;
    this.element = controller.element;

    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);

    this.element.addEventListener('touchstart', this.handleTouchStart, { passive: true });
    this.element.addEventListener('touchmove', this.handleTouchMove, { passive: true });
    this.element.addEventListener('touchend', this.handleTouchEnd);
    this.element.addEventListener('touchcancel', this.handleTouchEnd);
  }

  handleTouchStart(e) {
    const touch = e.touches[0];
    this.controller.handleStart(touch.clientX, touch.clientY, e);
  }

  handleTouchMove(e) {
    if (!this.controller.active) return;
    const touch = e.touches[0];
    this.controller.handleMove(touch.clientX, touch.clientY, e);
  }

  handleTouchEnd(e) {
    this.controller.handleEnd(e);
  }

  destroy() {
    this.element.removeEventListener('touchstart', this.handleTouchStart);
    this.element.removeEventListener('touchmove', this.handleTouchMove);
    this.element.removeEventListener('touchend', this.handleTouchEnd);
    this.element.removeEventListener('touchcancel', this.handleTouchEnd);
  }
}
